import { render, staticRenderFns } from "./ProposalPageLegacy.vue?vue&type=template&id=5ab7c0a8&scoped=true&"
import script from "./ProposalPageLegacy.vue?vue&type=script&lang=js&"
export * from "./ProposalPageLegacy.vue?vue&type=script&lang=js&"
import style0 from "./ProposalPageLegacy.vue?vue&type=style&index=0&id=5ab7c0a8&prod&lang=scss&"
import style1 from "./ProposalPageLegacy.vue?vue&type=style&index=1&id=5ab7c0a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab7c0a8",
  null
  
)

export default component.exports